import Vue from 'vue'
import Vuex from 'vuex'
import API from '../api'
import config from '../config'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sGroupId: config.sGroupId, // 活动id
    drawNum: -1, // 抽奖次数
    isLogin: false, // 是否有登录态
    loginShow: false, // 是否展现登陆弹
    myUserId: '',
    lotteryNum: 0
  },
  mutations: {
    // 设置sGroupId
    setsGroupId(state, payload) {
      state.sGroupId = payload
    },
    // 设置抽奖次数
    setDrawNum(state, payload) {
      state.drawNum = payload
    },
    // 设置手机号
    setPhone(state, payload) {
      state.phoneNum = payload
    },
    // 设置sGroupId
    SET_USERID(state, payload) {
      state.myUserId = payload
    },
    // 当前进度
    setLotteryNum(state, payload) {
      state.lotteryNum = payload
      console.log('lotterynum', state.lotteryNum)
    }
  },
  actions: {
    // 获取抽奖次数
    async getDrawNum({ state, commit }, payload = {}) {
      const res = await API.getUserInfo({
        sGroupId: state.sGroupId,
        userId: payload.userId
      })
      if (res.code === 0) {
        commit('setPhone', res.data.phone)
        // commit('setLotteryNum', res.data.usdNum)
      }
      return res.data

      // const data1 = {
      //   code: 0,
      //   data: { currentNum: 10, phone: '15010307600' },
      //   msg: '成功',
      //   stat: 1,
      //   unixTime: 1623263403
      // }
    }
  },
  modules: {}
})
